var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F0F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9991 65C54.7156 65 50.0171 67.5511 47.0258 71.5099C46.3819 72.362 46.06 72.788 46.0706 73.3638C46.0787 73.8086 46.358 74.3698 46.708 74.6445C47.1611 75 47.7889 75 49.0445 75H70.9537C72.2093 75 72.8371 75 73.2902 74.6445C73.6402 74.3698 73.9195 73.8086 73.9276 73.3638C73.9382 72.788 73.6163 72.362 72.9724 71.5099C69.9811 67.5511 65.2826 65 59.9991 65Z",
    stroke: "#274054",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9991 60C64.1412 60 67.4991 56.6421 67.4991 52.5C67.4991 48.3579 64.1412 45 59.9991 45C55.857 45 52.4991 48.3579 52.4991 52.5C52.4991 56.6421 55.857 60 59.9991 60Z",
    stroke: "#274054",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.964377fcb18a16c178cb27dc70a10f1f.svg";
export { ForwardRef as ReactComponent };